import CircularProgress from 'material-ui/CircularProgress';
import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import { Entities, fetchById, getUpdatedEntity, patch, save, search } from 'src/common/index';
import { setSliderIndex } from 'src/actions/form';
import CancellationOptionsEditForm from 'src/components/admin/cancellations/cancellation-options-edit-form';

class CancellationOptionEditModal extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            startedFetching: false,
        };
    }

    componentWillMount() {
        const { isCreate, id } = this.props;

        if (!isCreate) this.props.fetchById(id, Entities.CANCELLATION_OPTIONS);
        else this.setState({ startedFetching: true });
    }

    componentWillReceiveProps(nextProps) {
        const { cancellationOption } = nextProps;

        if (!this.state.startedFetching && cancellationOption.isFetching) this.setState({ startedFetching: true });
    }

    callSubmit() {
        return this.childForm.submit();
    }

    didFormChange() {
        return !this.childForm.pristine;
    }

    render() {
        const { isCreate, t, cancellationOption } = this.props;
        const finishFetching = this.state.startedFetching && !cancellationOption.isFetching;

        let initialValues;

        if (finishFetching) {
            if (!isCreate) {
                initialValues = cancellationOption;
            } else {
                initialValues = {};
            }
            return (
                <CancellationOptionsEditForm
                    initialValues={initialValues.content}
                    onSubmit={this.handleSubmit}
                    t={t}
                    ref={ref => (this.childForm = ref)}
                />
            );
        } else return <CircularProgress />;
    }

    handleSubmit(data) {
        const { isCreate, handleClose, patch, save } = this.props;

        if (isCreate) save(data, Entities.CANCELLATION_OPTIONS);
        else patch(data, Entities.CANCELLATION_OPTIONS);

        handleClose();
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        cancellationOption: getUpdatedEntity(state, Entities.CANCELLATION_OPTIONS),
    };
};

export default connect(
    mapStateToProps,
    {
        fetchById,
        search,
        patch,
        save,
        setSliderIndex,
    },
    null,
    { withRef: true },
)(CancellationOptionEditModal);
